<script>
    /**
     * Prompt
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter';
    import NormalButton from '../widgets/NormalButton.vue';
    import NormalInput from '../widgets/NormalInput';

    export default {
        alias: 'prompt',
        defaultOptions () {
            return {
                title: '提示',
                type: 'text'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {
                title: '',
                text: '',
                type: '',
                errortext: '',
                value:'',
                btnText: ['取消', '确定']
            };
        },
        name: 'modal-confirm',
        methods: {
            onConfirm () {
                this.errortext = '';
                const check = this.check && this.check(this.value);
                if (check === true || check === undefined) {
                    this.okCallback && this.okCallback(this.value);
                    this.close();
                } else if (typeof check === 'string') {
                    this.errortext = check;
                }
            },
            onDestroy () {
                this.cancelCallback && this.cancelCallback();
                this.close();
            }
        },
        components: {
            NormalInput,
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="normal-modal normal-modal-prompt">
        <modal-header>{{title}}</modal-header>
        <div class="normal-modal__bd">
            <p class="input-tips" v-html="text"></p>
            <normal-input v-model="value" class="normal-input-wrap" :type="type"></normal-input>
            <p class="input-text-error" v-if="errortext" v-html="errortext"></p>
        </div>
        <modal-footer>
            <normal-button @click.native="onDestroy();"
                           theme="default"
                           :is-modal="true"
            >{{btnText[0]}}
            </normal-button>
            <normal-button @click.native="onConfirm();"
                           theme="primary"
                           :is-modal="true"
            >{{btnText[1]}}
            </normal-button>
        </modal-footer>
    </div>
</template>
<style lang="less">
    .normal-modal.normal-modal-prompt {
        input {
            line-height: 0.8rem;
            height: 0.8rem;
        }

        textarea {
            height: 3rem;
        }
    }
</style>
<style lang="less" scoped>

    .input-tips {
        margin-bottom: 8px;
    }

    .input-text-error {
        color: @dangerBg;
    }

    .normal-input-wrap {
        border-radius: 5px;
        border: 1px solid @otherBorderClr;
    }
</style>
